import { type CSSProperties } from 'react'

export type SemanticAccentTone = 'info' | 'warning' | 'success' | 'danger'

const resourceTypeAccentById: Record<string, string> = {
	youtube: 'var(--chart-2)',
	googleBooks: 'var(--chart-1)',
	google_books: 'var(--chart-1)',
	serper_article: 'var(--chart-5)',
	webArticles: 'var(--chart-5)',
	serper_image: 'var(--secondary)',
}

const imageCollectionAccentColors = [
	'var(--secondary)',
	'var(--chart-1)',
	'var(--chart-2)',
] as const

const semanticToneClasses: Record<
	SemanticAccentTone,
	{
		subtleSurface: string
		softIcon: string
		emphasisText: string
	}
> = {
	info: {
		subtleSurface:
			'border-status-info-border bg-status-info-surface text-status-info-text',
		softIcon: 'bg-status-info-surface text-status-info-text',
		emphasisText: 'text-status-info-text',
	},
	warning: {
		subtleSurface:
			'border-status-warning-border bg-status-warning-surface text-status-warning-text',
		softIcon: 'bg-status-warning-surface text-status-warning-text',
		emphasisText: 'text-status-warning-text',
	},
	success: {
		subtleSurface:
			'border-status-success-border bg-status-success-surface text-status-success-text',
		softIcon: 'bg-status-success-surface text-status-success-text',
		emphasisText: 'text-status-success-text',
	},
	danger: {
		subtleSurface:
			'border-status-danger-border bg-status-danger-surface text-status-danger-text',
		softIcon: 'bg-status-danger-surface text-status-danger-text',
		emphasisText: 'text-status-danger-text',
	},
}

export function getResourceTypeAccentColor(resourceTypeId: string): string {
	return resourceTypeAccentById[resourceTypeId] ?? 'var(--muted-foreground)'
}

export function getResourceTypeMarkerStyle(
	resourceTypeId: string,
): CSSProperties {
	return {
		backgroundColor: getResourceTypeAccentColor(resourceTypeId),
	}
}

export function getImageCollectionAccentStyles(): CSSProperties[] {
	return imageCollectionAccentColors.map((backgroundColor) => ({
		backgroundColor,
	}))
}

export function getSemanticToneClasses(tone: SemanticAccentTone) {
	return semanticToneClasses[tone]
}
